import { ReactElement } from 'react';

import Subscription from '~components/Subscription';

import DashboardVariantV2CarrierContentInWarehouseTabProvider from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentInWarehouseTabActions,
  DashboardVariantV2CarrierContentInWarehouseTabCurrenFilters,
  DashboardVariantV2CarrierContentInWarehouseTabDataTable,
  DashboardVariantV2CarrierContentInWarehouseTabMap,
} from './Components';

const DashboardVariantV2CarrierContentInWarehouseTab = (): ReactElement => (
  <DashboardVariantV2CarrierContentInWarehouseTabProvider>
    <DashboardVariantV2CarrierContentTabContainer>
      <DashboardVariantV2CarrierContentInWarehouseTabActions />

      <DashboardVariantV2CarrierContentInWarehouseTabCurrenFilters />

      <div>
        <Subscription.AvailableRoutesState.Alert
          withButtons
          withCloseAction
          sx={(currentTheme) => ({
            padding: currentTheme.spacing(0, 2, 2, 2),
          })}
        />
      </div>

      <DashboardVariantV2CarrierContentWrapper>
        <DashboardVariantV2CarrierContentInWarehouseTabDataTable />

        <DashboardVariantV2CarrierContentInWarehouseTabMap />
      </DashboardVariantV2CarrierContentWrapper>
    </DashboardVariantV2CarrierContentTabContainer>
  </DashboardVariantV2CarrierContentInWarehouseTabProvider>
);

export default DashboardVariantV2CarrierContentInWarehouseTab;
